function read_local_storage_item(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export default {
  get_messages_preview(messages) {
    const last_message = [...(messages || [])].reverse().find((message) => (
      String(message?.text || "").trim()
    ));
    return last_message?.text || "";
  },

  restore_active_conversation(preferred_active_id = null) {
    const saved_active_id = preferred_active_id || this.read_active_conversation_id();
    const has_saved_active = this.conversations.some(
      (item) => item.id === saved_active_id
    );
    this.active_conversation_id = has_saved_active
      ? saved_active_id
      : this.conversations[0]?.id || null;
  },

  read_active_conversation_id() {
    return read_local_storage_item(this.active_storage_key);
  },

  save_active_conversation(id) {
    if (!id) return false;

    try {
      localStorage.setItem(this.active_storage_key, id);
      return true;
    } catch {
      return false;
    }
  },

  start_new_conversation(options = {}) {
    if (options.reuse_empty_active && this.is_empty_local_conversation(this.active_conversation)) {
      this.user_message = "";
      return;
    }

    const conversation = this.create_conversation();
    this.conversations.unshift(conversation);
    this.active_conversation_id = conversation.id;
    this.user_message = "";
  },

  is_empty_local_conversation(conversation) {
    return this.is_local_conversation(conversation)
      && this.has_no_user_messages(conversation)
      && this.has_only_welcome_message(conversation);
  },

  is_local_conversation(conversation) {
    return Boolean(conversation) && conversation.source !== "backend";
  },

  has_no_user_messages(conversation) {
    const messages = conversation.messages || [];

    return !messages.some((message) => message.sender === "user");
  },

  has_only_welcome_message(conversation) {
    const messages = conversation.messages || [];
    const assistant_messages = messages.filter((message) => message.sender === "assistant");

    return assistant_messages.length === 1
      && assistant_messages[0].text === "Hello! I'm Jeffrey. How can I help you today?";
  },

  select_conversation(id) {
    this.active_conversation_id = id;
    this.ensure_active_conversation_messages(id);
  },

  get_conversation_by_id(conversation_id) {
    return this.conversations.find((item) => item.id === conversation_id) || null;
  },

  delete_conversation(id) {
    if (this.conversations.length <= 1) return;

    const conversation = this.get_conversation_by_id(id);
    if (conversation?.source === "backend") return;

    const index = this.conversations.findIndex((item) => item.id === id);
    this.conversations = this.conversations.filter((item) => item.id !== id);
    if (this.active_conversation_id !== id) return;

    const next_index = Math.max(0, Math.min(index, this.conversations.length - 1));
    this.active_conversation_id = this.conversations[parseInt(next_index, 10)].id;
  },

  touch_active_conversation() {
    if (!this.active_conversation) return;
    this.active_conversation.updated_at = new Date().toISOString();
    this.active_conversation.preview = this.get_messages_preview(this.active_conversation.messages);
  },

  touch_conversation(conversation_id) {
    const conversation = this.get_conversation_by_id(conversation_id);
    if (!conversation) return;
    conversation.updated_at = new Date().toISOString();
    conversation.preview = this.get_messages_preview(conversation.messages) || conversation.preview;
  },

  get_conversation_title(conversation) {
    const first_user_message = conversation.messages?.find(
      (message) => message.sender === "user"
    );
    return first_user_message?.text || conversation.title || "New conversation";
  },
};
